


























import { Component, Vue, Prop } from "vue-property-decorator";
import DateTimePicker from "./DateTimePicker.vue";

@Component({
  components: {
    DateTimePicker,
  },
})
export default class LongQuestion extends Vue {
  @Prop() protected text: string;
  @Prop() protected rows: number;
  @Prop() protected resize: boolean;
  @Prop() protected value: string;
  @Prop() protected component?: {
    name: string;
    props: { [key: string]: any };
  };

  get resizeValue() {
    return this.resize ? "both" : "none";
  }

  get rowsValue() {
    return this.rows ? this.rows : 3;
  }

  protected valueChanged(e: FocusEvent) {
    this.$emit("blur", e);
  }
}
